export const percentage = (perc, total) => perc * total;

let randomFunc;

export const initRandom = (random) => (randomFunc = random);

export const randomArr = (arr, random = randomFunc) =>
  arr[Math.floor(random() * arr.length)];

export const getArrAdjacent = (val, arr, adjacentLength) => {
  const idx = arr.findIndex((i) => i === val);

  const min = (idx + arr.length - adjacentLength) % arr.length;
  const max = min + adjacentLength * 2;

  return new Array(adjacentLength)
    .fill(0)
    .flatMap((_, idx) => {
      return [idx + min, max - idx];
    })
    .map((idx) => arr[idx % arr.length]);
};

export const randomArrAdjacent = (
  val,
  arr,
  adjacentLength,
  random = randomFunc
) => {
  const options = getArrAdjacent(val, arr, adjacentLength);

  return randomArr(options, random);
};

export const randomNum = (total, random = randomFunc) => random() * total;

export const randomNumBetween = (max, min = 0, random = randomFunc) =>
  random() * (max - min) + min;

export const getSeed = (total = 10000) => {
  return Math.floor(randomNum(total, Math.random))
    .toString()
    .padStart(total.toString().length, 0);
};

export const getParam = (key, defaultValue) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key) || defaultValue;
};

export const getServerParam = (key, defaultValue) => {
  const options = process.argv.slice(2).reduce((p, v, idx, arr) => {
    if (v.startsWith("--")) {
      return {
        ...p,
        [v.slice(2)]: arr[idx + 1],
      };
    }

    return p;
  }, {});

  return options[key] || defaultValue;
};

export const mapRange = (val, in_min, in_max, out_min, out_max) => {
  return ((val - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
};

export const remapNormal = (val) => {
  return mapRange(val, -1, 1, 0, 1);
};

export const unique = (arr) => [...new Set(arr)];

export const lerp = (v0, v1, t) => {
  return v0 * (1 - t) + v1 * t;
};

export const deg2rad = (degrees) => {
  return degrees * (Math.PI / 180);
};

export const addInfo = (title, txt, browser = true) => {
  if (!browser) {
    console.log(`${title}:`, txt);
    return;
  }

  const id = title.split(" ").join("-");
  const existing = document.getElementById(id);

  if (existing) {
    existing.innerText = `${title}: ${txt}`;
  } else {
    const el = document.createElement("span");
    el.id = id;
    el.innerText = `${title}: ${txt}`;

    document.querySelector(".info").appendChild(el);
  }
};

export const scoreWeight = (scores, browser = true) => {
  return scores
    .map(({ score, weight, key }, idx, arr) => {
      const weighted = score * (weight || 1 / arr.length);
      addInfo(`Evaluate (${key || idx})`, score, browser);
      return weighted;
    })
    .reduce((p, c) => p + c, 0);
};

function toHex(str) {
  var result = "";
  for (var i = 0; i < str.length; i++) {
    result += str.charCodeAt(i).toString(16);
  }
  return result;
}

export const seedToName = (seed) => {
  const alpha = `abcdefghijklmnopqrstuvwxyz`;
  const reduction = seed
    .split("")
    .map((v) => parseInt(v))
    .reduce((p, c) => p + c, 0);

  const parts = [seed];

  // if (reduction % 3 === 0) {
  parts.push(alpha.charAt(reduction % 26).toUpperCase());
  // }

  if (reduction % 2 === 0) {
    parts.push(reduction % 10);
  }

  // const hex = toHex(seed);
  // parts.push(alpha.charAt(parseInt(hex.charAt(0))).toUpperCase());

  return parts.join("-");
};
